import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-beneficio-direita',
  templateUrl: './beneficio-direita.component.html',
  styleUrls: ['./beneficio-direita.component.scss']
})

export class BeneficioDireitaComponent implements OnInit {
  @Input() data;

  constructor() {
  }

  ngOnInit() {
  }

}
